import React from 'react';
import { Box, IconButton, Menu } from '@mui/material';
import { bindMenu, bindTrigger, usePopupState } from 'material-ui-popup-state/hooks';

import { More } from '@icons/index';

interface MoreOptionsComponentProps {
  options?: JSX.Element[];
}

const MoreOptionsComponent = (props: MoreOptionsComponentProps) => {
  const { options } = props;

  const menu = usePopupState({ popupId: 'options-menu', variant: 'popover' });

  return (
    <Box position="relative">
      <IconButton sx={{ height: '40px', width: '40px' }} {...bindTrigger(menu)} disableRipple>
        <More />
      </IconButton>
      <Menu
        {...bindMenu(menu)}
        sx={{ mt: '-40px', zIndex: 1 }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
        {options}
      </Menu>
    </Box>
  );
};

export default MoreOptionsComponent;